module.exports = __webpack_public_path__ + "img/close.8c8f7327.svg";